import React from 'react';
import VideoPlayer from 'cccisd-video-player';

const Boilerplate = window.cccisd && window.cccisd.boilerplate;

const Tutorial = props => {
    return (
        <div>
            <p>
                Watch the Registration Walk-through Video or download the{' '}
                <a
                    href={Boilerplate.url('/api/resources/file/public/2023_NYOI%20RegistrationGuide.pdf')}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-nowrap"
                >
                    Registration Walk-through PDF
                </a>
                .
            </p>
            <VideoPlayer url="https://player.vimeo.com/video/501020671" width={868} height={550} controls />
        </div>
    );
};

Tutorial.propTypes = {};

Tutorial.defaultProps = {};

export default Tutorial;
